import * as React from 'react'
import styled from 'styled-components'
import TripMap from './TripMap'

const DesktopRoot = styled.div`
  height: 100%;
`

export function DesktopTripMap(props: React.ComponentProps<typeof TripMap>) {
  return (
    <DesktopRoot>
      <TripMap {...props} />
    </DesktopRoot>
  )
}
